import types from './types';

const getHazardStatementAutocompleteList = () => ({
  type: types.GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST
});

const getEuhStatementAutocompleteList = () => ({
  type: types.GET_EUH_STATEMENT_AUTOCOMPLETE_LIST
});

export default {
  getHazardStatementAutocompleteList, 
  getEuhStatementAutocompleteList
};
